import { __rest, __assign } from 'tslib';
import clsx from 'clsx';
import React, { forwardRef } from 'react';

var ButtonBase = forwardRef(function (_a, ref) {
    var children = _a.children, icon = _a.icon, designSize = _a.designSize, block = _a.block, typeClass = _a.typeClass, className = _a.className, type = _a.type, buttonProps = __rest(_a, ["children", "icon", "designSize", "block", "typeClass", "className", "type"]);
    return (React.createElement("button", __assign({ ref: ref }, buttonProps, { type: type, className: clsx(className, { 'c-btn--block': block }, 'c-btn', "c-btn--".concat(typeClass), designSize ? "c-btn--".concat(designSize) : undefined) }),
        React.createElement(ButtonIcon, null, icon),
        children));
});
var PrimaryButton = forwardRef(function (_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(ButtonBase, __assign({}, props, { typeClass: 'primary', ref: ref }), children));
});
var SecondaryButton = forwardRef(function (_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(ButtonBase, __assign({}, props, { typeClass: 'secondary', ref: ref }), children));
});
var OutlineButton = forwardRef(function (_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(ButtonBase, __assign({}, props, { typeClass: 'outline', ref: ref }), children));
});
var InfoButton = forwardRef(function (_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(ButtonBase, __assign({}, props, { typeClass: 'info', ref: ref }), children));
});
var LinkButton = forwardRef(function (_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(ButtonBase, __assign({}, props, { typeClass: 'link', ref: ref }), children));
});
var WhiteButton = forwardRef(function (_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(ButtonBase, __assign({}, props, { typeClass: 'white', ref: ref }), children));
});
var ButtonIcon = function (_a) {
    var children = _a.children;
    return children ? React.createElement("span", { className: 'c-link-icon' }, children) : null;
};

export { ButtonBase, InfoButton, LinkButton, OutlineButton, PrimaryButton, SecondaryButton, WhiteButton };
//# sourceMappingURL=index.js.map
